interface AppropriatenessItem {
  status: boolean;
  isManuallyPassedByAdmin: boolean;
  isExpired: boolean;
  attempt?: number;
}

export enum AppropriatenessStatusLabel {
  NotAttempted = 'Not attempted',
  AdminPass = 'Admin pass',
  TestReset = 'Test reset',
  Expired = 'Expired',
  Fail = 'Fail',
  Pass = 'Pass',
}

export const getCurrentAppropriatenessStatusLabel = (
  appropriatenessItem?: AppropriatenessItem,
): AppropriatenessStatusLabel => {
  if (!appropriatenessItem) return AppropriatenessStatusLabel.NotAttempted;

  if (appropriatenessItem.status && appropriatenessItem.isManuallyPassedByAdmin)
    return AppropriatenessStatusLabel.AdminPass;

  if (!appropriatenessItem.status && appropriatenessItem.attempt === 0) {
    return AppropriatenessStatusLabel.TestReset;
  }

  if (!appropriatenessItem.status && appropriatenessItem.isExpired)
    return AppropriatenessStatusLabel.Expired;

  return appropriatenessItem.status
    ? AppropriatenessStatusLabel.Pass
    : AppropriatenessStatusLabel.Fail;
};
